import { Container, Grid, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { FaCircle } from "react-icons/fa";
import Button from "@mui/material/Button";
import { BsGithub } from "react-icons/bs";
import { MdOutlineOpenInNew } from "react-icons/md";
import IconButton from "@mui/material/IconButton";

let theme = createTheme();
theme = responsiveFontSizes(theme);

const useStyles = makeStyles(() => {
  return {
    comingsoon: {
      fontFamily: "Rubik",
      fontWeight: 300,
      color: "#757575",
    },
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
    },
    typoTextRight: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
      textAlign: "right",
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
    },
    typoSubheadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 500,
    },
    image: {
      "&:hover": {
        opacity: "0.5",
        transition: "ease-in-out",
        transitionDuration: "0.2s",
      },
    },
    but: {
      fontSize: 20,
    },
  };
});

const Section3 = () => {
  const classes = useStyles();

  return (
    <>
      <Container
        sx={{ paddingTop: 20 }}
        id="web"
        data-aos="fade-up"
        data-aos-offset="250"
        data-aos-duration="800"
      >
        <Grid container justifyContent="center">
          <Grid item sx={{ textAlign: "center" }}>
            <Typography className={classes.typoHeadline} variant="h3">
              Technologies i use
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          spacing={1}
          sx={{ marginTop: 6 }}
        >
          <Grid item>
            <img
              src="c.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="html.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="css.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="javascript.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="react.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="next.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="node.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="mongo.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="firebase.svg"
              width="70%"
              height="70%"
              className={classes.image}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.typoSubheadline}>
              Projects
            </Typography>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Collabs
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - classroom management system
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Reactjs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#FFCB2B",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Firebase
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#FE787B",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Chartjs
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open(
                          "https://github.com/MusabShk/collabs-classrooms"
                        )
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://collabs-classrooms.netlify.app/")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Mininsta
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - social media webapp
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Reactjs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#303030",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Nodejs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#4db33d",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; MongoDB
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://github.com/MusabShk/mininsta")
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://github.com/MusabShk/mininsta")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Weather Feeds
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - find weather updates of cities
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Reactjs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#EB6D4A",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; OpenWeatherMap API
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://github.com/MusabShk/Weather-Feeds")
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://weatherfeeds.netlify.app/")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      FacereAlbum
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - note down things ToDo
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Reactjs
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open(
                          "https://github.com/MusabShk/FacereAlbum-ToDo-List"
                        )
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://facerealbum.netlify.app/")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Eidetic
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - webapp to share your memories
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#000000",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Nextjs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#4db33d",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; MongoDB
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://github.com/MusabShk/eidetic")
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://eidetic-omega.vercel.app/")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Youtube Pocket
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - Enjoy all your Youtube content on this webapp
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Reactjs
                      </span>
                    </span>
                    <span>
                      <FaCircle
                        style={{
                          color: "#FF0000",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; Youtube API
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "right" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open(
                          "https://github.com/MusabShk/Youtube-Pocket"
                        )
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://youtubepocket.vercel.app/")
                      }
                    >
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sx={{ flexGrow: 1, paddingTop: 4 }} xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Grid container spacing={2}>
                  {/* <Grid item xs={1} md={"auto"}>
                    <img src="1.svg" />
                  </Grid> */}
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span variant="h6" className={classes.typoSubheadline}>
                      Spanish Number
                    </span>
                    <span variant="h6" className={classes.typoText}>
                      - an audio native mobile app to learn spanish numbers
                    </span>
                    {/* <Typography
                      variant="h6"
                      className={classes.typoSubheadline}
                    >
                      Collabs
                    </Typography> */}
                  </Grid>
                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                  <Grid item xs={12} md={"auto"} sx={{ marginTop: 1 }}>
                    <span>
                      <FaCircle
                        style={{
                          color: "#61DBFB",
                          fontSize: 12,
                          marginLeft: 10,
                        }}
                      />
                      <span variant="h6" className={classes.typoText}>
                        &nbsp; React Native
                      </span>
                    </span>
                  </Grid>
                  <Grid item xs={12} md={"auto"} sx={{ textAlign: "center" }}>
                    <IconButton
                      size="large"
                      sx={{ borderRadius: "100%" }}
                      onClick={() =>
                        window.open("https://github.com/MusabShk/SpanishNumber")
                      }
                    >
                      <img
                        src="aka.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "40%",
                        }}
                      />
                    </IconButton>
                  </Grid>
                  {/* <Grid item xs={6} md={"auto"} sx={{ textAlign: "left" }}>
                    <IconButton size="large" sx={{ borderRadius: "100%" }}>
                      <img
                        src="link.svg"
                        width="100%"
                        height="100%"
                        style={{
                          boxShadow: "2px 2px 8px 4px #E8ECFF",
                          borderRadius: "30%",
                        }}
                      />
                    </IconButton>
                  </Grid> */}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item sx={{ marginTop: 5 }}>
            <Typography variant="body2" className={classes.comingsoon}>
              View all projects on github
              <IconButton
                size="large"
                sx={{ borderRadius: "100%" }}
                onClick={() => window.open("https://github.com/MusabShk/")}
              >
                <img
                  src="aka.svg"
                  width="100%"
                  height="100%"
                  style={{
                    boxShadow: "2px 2px 8px 4px #E8ECFF",
                    borderRadius: "40%",
                  }}
                />
              </IconButton>
              {/* <Button
                size="large"
                sx={{
                  textTransform: "none",
                  textShadow: "0 0 3px #A9B8FF",
                  color: "#000",
                }}
                onClick={() => window.open("https://github.com/MusabShk/")}
              >
                Github
              </Button> */}
              {/* <span
                style={{ color: "#000", textShadow: "0 0 3px #A9B8FF" }}
                onClick={() => window.open("https://github.com/MusabShk")}
              >
                Github
              </span> */}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Section3;
